import { FONT_TITLE, FONT_COPY } from 'app/constants/AppConstants';

export default class OverlayInstructions extends Phaser.Group {
  constructor(game) {
    super(game);

    this.onClose = new Phaser.Signal();

    // overlay
    this.overlay = this.game.make.image(0, 0, 'foodgame_overlay');
    this.addChild(this.overlay);
    this.overlay.inputEnabled = true;

    // panel
    this.panel = this.game.make.image(
      this.game.defaultWidth / 2,
      this.game.defaultHeight / 2,
      'foodgame_gui',
      'instructions_panel.png'
    );
    this.panel.anchor.set(0.5);
    this.addChild(this.panel);

    // image
    this.image = this.game.make.image(0, 0);
    this.image.anchor.set(0.5, 1);
    this.panel.addChild(this.image);

    // texture
    this.texture = this.game.make.image(0, 0, 'foodgame_gui', 'instructions_texture.png');
    this.texture.anchor.set(0.5);
    this.texture.blendMode = PIXI.blendModes.MULTIPLY;
    this.texture.alpha = 0.35;
    this.panel.addChild(this.texture);

    // text
    this.label = this.game.make.text(0, -136, this.game.copy.getCopy('foodgame_instruction_01'), {
      font: '42px ' + this.game.titleFontStyle,
      fill: '#0090C1',
      wordWrap: true,
      wordWrapWidth: 380,
      align: 'center',
    });
    this.label.anchor.set(0.5);
    this.panel.addChild(this.label);

    //
    this.showPage1();
  }

  showPage1() {
    let type = this.game.device.desktop ? 'd' : 't';
    this.label.text = this.game.copy.getCopy('foodgame_instruction_01');
    this.image.loadTexture('foodgame_gui', 'instructions_image_1' + type + '.png');
    this.image.y = 207;

    this.btnNext = this.game.make.button(
      327,
      -200,
      'foodgame_gui',
      null,
      null,
      'btn_next.png',
      'btn_next.png'
    );
    this.btnNext.anchor.set(0.5);
    this.btnNext.onInputDown.add(this.handlePressNext, this);
    this.panel.addChild(this.btnNext);
  }

  handlePressNext() {
    this.btnNext.destroy();
    this.btnNext = null;
    this.showPage2();
  }

  showPage2() {
    let type = this.game.device.desktop ? 'd' : 't';
    this.label.text = this.game.copy.getCopy('foodgame_instruction_02');
    this.image.loadTexture('foodgame_gui', 'instructions_image_2' + type + '.png');
    this.image.y = 207;

    this.btnClose = this.game.make.button(
      327,
      -200,
      'buttons_sprite',
      null,
      null,
      'btn_close_white',
      'btn_close_pink'
    );
    this.btnClose.anchor.set(0.5);
    this.btnClose.onInputDown.add(this.handlePressClose, this);
    this.panel.addChild(this.btnClose);
  }

  handlePressClose() {
    this.onClose.dispatch();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/ui/OverlayInstructions.js